module.exports = __webpack_public_path__ + "static/media/iveco.ccc2cf4c.jpg";